<template>
  <section id="features" class="py-20 bg-slate-900 text-white">
    <div class="container mx-auto px-6">
      <div class="mb-16 text-center">
        <h2 class="text-3xl md:text-4xl font-bold mb-4">关于我</h2>
        <div class="w-20 h-1 bg-blue-500 mx-auto rounded-full"></div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <!-- About Card -->
        <div class="md:col-span-2 bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 hover:border-slate-600 transition-all">
          <div class="flex items-center mb-6">
            <div class="p-3 bg-blue-500/20 rounded-lg text-blue-400 mr-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <h3 class="text-2xl font-semibold">我是谁</h3>
          </div>
          <p class="text-slate-300 leading-relaxed text-lg">
            我是 xiaoyang，一名充满热情的开发者。我喜欢折腾各种新技术，并致力于开源社区的贡献。
            在这里，你可以看到我的技术积累、项目展示以及学习心得。希望能与更多志同道合的朋友一起成长，共同探索代码的无限可能。
          </p>
          <div class="mt-8">
            <a href="/docs" class="inline-flex items-center text-blue-400 hover:text-blue-300 font-medium transition-colors">
              了解更多关于我的故事 <span class="ml-2">→</span>
            </a>
          </div>
        </div>

        <!-- Stats/Quick Info Card -->
        <div class="bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 hover:border-slate-600 transition-all flex flex-col justify-center">
           <h3 class="text-xl font-semibold mb-6">快速概览</h3>
           <div class="space-y-4">
             <div class="flex justify-between items-center pb-4 border-b border-slate-700">
               <span class="text-slate-400">坐标</span>
               <span class="font-medium">中国 · 互联网</span>
             </div>
             <div class="flex justify-between items-center pb-4 border-b border-slate-700">
               <span class="text-slate-400">主要领域</span>
               <span class="font-medium">全栈开发</span>
             </div>
             <div class="flex justify-between items-center">
               <span class="text-slate-400">爱好</span>
               <span class="font-medium">编码, 音乐, 探索</span>
             </div>
           </div>
        </div>

        <!-- Tech Stack Card -->
        <div class="md:col-span-3 bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 hover:border-slate-600 transition-all">
          <div class="flex items-center mb-8">
            <div class="p-3 bg-purple-500/20 rounded-lg text-purple-400 mr-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <h3 class="text-2xl font-semibold">技术栈</h3>
          </div>
          
          <div class="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-8 gap-4">
            <div v-for="(tech, index) in techStack" :key="index" class="flex flex-col items-center justify-center p-4 bg-slate-900/50 rounded-xl border border-slate-700 hover:bg-slate-700/50 transition-colors">
              <div class="text-3xl mb-2">{{ tech.icon }}</div>
              <span class="text-sm text-slate-300">{{ tech.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const techStack = [
  { icon: '⚛️', name: 'React' },
  { icon: '🔥', name: 'Vue.js' },
  { icon: '🚀', name: 'Node.js' },
  { icon: '🐍', name: 'Python' },
  { icon: '☕', name: 'Java' },
  { icon: '🌐', name: 'Web' },
  { icon: '📱', name: 'Mobile' },
  { icon: '🤖', name: 'AI' }
];
</script>

<style scoped>
</style>
